import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a9e68a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change_payment_frame_wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content_wrapper client_wrapper" }
const _hoisted_4 = { class: "top_buttons_wrapper_end" }
const _hoisted_5 = {
  key: 0,
  class: "flex mb-3"
}
const _hoisted_6 = {
  key: 0,
  class: "tab_body"
}
const _hoisted_7 = { class: "profile_wrapper" }
const _hoisted_8 = { class: "photo_wrapper" }
const _hoisted_9 = { class: "img_wrapper" }
const _hoisted_10 = { class: "img_block position-relative" }
const _hoisted_11 = { class: "photo_text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "camera_img",
  src: "/assets/img/camera.svg"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "img_block" }
const _hoisted_15 = { class: "photo_text" }
const _hoisted_16 = { class: "photo_buttons_wrapper" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "data_wrapper" }
const _hoisted_19 = { class: "client_info_wrapper" }
const _hoisted_20 = { class: "client_info_title" }
const _hoisted_21 = { class: "w-100" }
const _hoisted_22 = { class: "client_info_fi" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/alert.svg" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "edit_img",
  src: "/assets/img/ellipsis.svg"
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "edit_menu" }
const _hoisted_29 = { class: "client_info_body" }
const _hoisted_30 = { class: "first_block_wrapper" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "one_block_wrapper mt-3" }
const _hoisted_33 = { class: "block_label" }
const _hoisted_34 = {
  key: 1,
  class: "block_row"
}
const _hoisted_35 = { class: "two_block_wrapper mt-3" }
const _hoisted_36 = { class: "block_label" }
const _hoisted_37 = { class: "two_block_wrapper mt-3" }
const _hoisted_38 = { class: "block_label" }
const _hoisted_39 = {
  key: 1,
  class: "block_info"
}
const _hoisted_40 = { class: "block_row" }
const _hoisted_41 = { class: "two_block_wrapper mt-3" }
const _hoisted_42 = { class: "block_label" }
const _hoisted_43 = { class: "two_block_wrapper mt-3" }
const _hoisted_44 = { class: "block_label" }
const _hoisted_45 = { class: "block_info" }
const _hoisted_46 = { class: "second_block_wrapper" }
const _hoisted_47 = { class: "block_row" }
const _hoisted_48 = { class: "two_block_wrapper mt-3" }
const _hoisted_49 = { class: "block_label" }
const _hoisted_50 = { class: "block_info club_name_info" }
const _hoisted_51 = { class: "two_block_wrapper mt-3" }
const _hoisted_52 = { class: "block_label" }
const _hoisted_53 = {
  key: 0,
  class: "flex"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot dot_disable" }, null, -1))
const _hoisted_55 = {
  key: 1,
  class: "flex"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot dot_active" }, null, -1))
const _hoisted_57 = {
  key: 2,
  class: "flex"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot dot_disable" }, null, -1))
const _hoisted_59 = { class: "in_club_status" }
const _hoisted_60 = {
  key: 3,
  class: "flex"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot dot_active" }, null, -1))
const _hoisted_62 = { class: "in_club_status" }
const _hoisted_63 = { class: "block_row" }
const _hoisted_64 = { class: "two_block_wrapper mt-3" }
const _hoisted_65 = { class: "block_label" }
const _hoisted_66 = { class: "block_info" }
const _hoisted_67 = { class: "two_block_wrapper mt-3" }
const _hoisted_68 = { class: "block_label" }
const _hoisted_69 = { class: "block_info" }
const _hoisted_70 = { class: "client_info_wrapper" }
const _hoisted_71 = { class: "client_edit" }
const _hoisted_72 = { class: "edit_client_elment_wrapper" }
const _hoisted_73 = { class: "edit_client_elment_wrapper" }
const _hoisted_74 = { class: "edit_client_elment_wrapper" }
const _hoisted_75 = { class: "edit_client_elment_wrapper" }
const _hoisted_76 = { class: "edit_client_elment_wrapper" }
const _hoisted_77 = { class: "edit_client_elment_wrapper" }
const _hoisted_78 = { class: "edit_client_button_wrapper" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 0,
  class: "client_info_wrapper"
}
const _hoisted_81 = { class: "client_info_title_contract flex" }
const _hoisted_82 = { class: "w-100" }
const _hoisted_83 = { class: "client_info_agreement_row" }
const _hoisted_84 = ["title"]
const _hoisted_85 = { class: "flex" }
const _hoisted_86 = { class: "client_info_contract" }
const _hoisted_87 = {
  key: 1,
  class: "flex client_info_contract_status"
}
const _hoisted_88 = { class: "client_info_contract_status_description" }
const _hoisted_89 = {
  key: 0,
  class: "flex"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "contract_switch_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = { class: "contract_switch_text" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "contract_switch_button_img",
  src: "/assets/img/arrow-right.svg"
}, null, -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = { class: "client_info_body_contract" }
const _hoisted_96 = { class: "client_info_body_contract_data" }
const _hoisted_97 = { class: "first_block_wrapper" }
const _hoisted_98 = { class: "block_row" }
const _hoisted_99 = { class: "two_block_wrapper mt-3" }
const _hoisted_100 = { class: "block_label" }
const _hoisted_101 = { class: "block_info" }
const _hoisted_102 = { class: "two_block_wrapper mt-3" }
const _hoisted_103 = { class: "block_label" }
const _hoisted_104 = { class: "block_info" }
const _hoisted_105 = { class: "second_block_wrapper" }
const _hoisted_106 = { class: "block_row" }
const _hoisted_107 = { class: "two_block_wrapper mt-3" }
const _hoisted_108 = { class: "block_label" }
const _hoisted_109 = { class: "block_info" }
const _hoisted_110 = { class: "two_block_wrapper mt-3" }
const _hoisted_111 = { class: "block_label" }
const _hoisted_112 = { class: "block_info" }
const _hoisted_113 = {
  key: 0,
  class: "client_info_body_contract_data"
}
const _hoisted_114 = { class: "first_block_wrapper" }
const _hoisted_115 = { class: "block_row" }
const _hoisted_116 = { class: "two_block_wrapper mt-3" }
const _hoisted_117 = { class: "block_label" }
const _hoisted_118 = { class: "block_info" }
const _hoisted_119 = { class: "client_info_body_contract_data" }
const _hoisted_120 = { class: "first_block_wrapper" }
const _hoisted_121 = { class: "one_block_wrapper mt-3" }
const _hoisted_122 = { class: "block_label" }
const _hoisted_123 = {
  key: 0,
  class: "flex"
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot dot_contract_active mr-2" }, null, -1))
const _hoisted_125 = { class: "block_info" }
const _hoisted_126 = { class: "contract_payment_date" }
const _hoisted_127 = {
  key: 1,
  class: "flex"
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block_info" }, "-", -1))
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = { class: "second_block_wrapper" }
const _hoisted_131 = { class: "one_block_wrapper mt-3" }
const _hoisted_132 = { class: "block_label" }
const _hoisted_133 = ["title"]
const _hoisted_134 = {
  key: 0,
  class: "flex"
}
const _hoisted_135 = { class: "block_info" }
const _hoisted_136 = { class: "contract_payment_date" }
const _hoisted_137 = {
  key: 0,
  class: "next_payment_service_type"
}
const _hoisted_138 = {
  key: 1,
  class: "flex"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block_info" }, "-", -1))
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = {
  key: 2,
  class: "client_info_contract_following_payment"
}
const _hoisted_142 = {
  key: 1,
  class: "client_info_body_contract_data"
}
const _hoisted_143 = { class: "mt-3 w-100" }
const _hoisted_144 = { class: "block_label" }
const _hoisted_145 = { class: "services_wrapper" }
const _hoisted_146 = { class: "service_wrapper" }
const _hoisted_147 = { class: "service" }
const _hoisted_148 = { class: "service_data_wrapper" }
const _hoisted_149 = { class: "mt-0 mb-0 mr-2" }
const _hoisted_150 = { class: "mt-0 mb-0 service_price" }
const _hoisted_151 = { class: "flex client_info_servicecontract_status" }
const _hoisted_152 = { class: "client_info_wrapper" }
const _hoisted_153 = { class: "client_info_title" }
const _hoisted_154 = { class: "comments_title" }
const _hoisted_155 = { class: "client_info_comments" }
const _hoisted_156 = { class: "comments_add_button_text" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: "/assets/img/plus.svg"
}, null, -1))
const _hoisted_158 = { class: "comments_show_button" }
const _hoisted_159 = ["src"]
const _hoisted_160 = { class: "client_info_comment_body" }
const _hoisted_161 = { class: "comment_wrapper" }
const _hoisted_162 = { class: "comment_title" }
const _hoisted_163 = { class: "comment_author" }
const _hoisted_164 = { class: "comment_date" }
const _hoisted_165 = ["onClick"]
const _hoisted_166 = ["innerHTML"]
const _hoisted_167 = { class: "client_info_wrapper" }
const _hoisted_168 = { class: "client_edit" }
const _hoisted_169 = { class: "edit_client_button_wrapper" }
const _hoisted_170 = ["disabled"]
const _hoisted_171 = {
  key: 1,
  class: "tab_body"
}
const _hoisted_172 = { class: "mt-3 total_wrapper" }
const _hoisted_173 = { class: "mt-1" }
const _hoisted_174 = {
  key: 2,
  class: "tab_body"
}
const _hoisted_175 = { class: "mb-1" }
const _hoisted_176 = {
  key: 0,
  class: "paymeant_mean"
}
const _hoisted_177 = { class: "paymeant_mean_data" }
const _hoisted_178 = { class: "paymeant_mean_data" }
const _hoisted_179 = { class: "paymeant_mean_data" }
const _hoisted_180 = { class: "paymeant_mean_data mb-0" }
const _hoisted_181 = {
  key: 1,
  class: "paymeant_error"
}
const _hoisted_182 = { class: "payment_buttons_wrapper" }
const _hoisted_183 = { class: "payment_select_wrapper" }
const _hoisted_184 = { class: "filter_wrapper pt-2" }
const _hoisted_185 = { class: "filter_left_wrapper" }
const _hoisted_186 = { class: "filter_right_wrapper" }
const _hoisted_187 = { src: "/assets/img/filter.svg" }
const _hoisted_188 = { class: "mt-3 total_wrapper" }
const _hoisted_189 = { class: "total" }
const _hoisted_190 = { class: "filter_wrapper pt-2" }
const _hoisted_191 = { class: "filter_left_wrapper" }
const _hoisted_192 = { class: "filter_right_wrapper" }
const _hoisted_193 = { src: "/assets/img/filter.svg" }
const _hoisted_194 = { class: "mt-3 total_wrapper" }
const _hoisted_195 = { class: "total" }
const _hoisted_196 = {
  key: 3,
  class: "tab_body"
}
const _hoisted_197 = { class: "filter_wrapper pt-2" }
const _hoisted_198 = { class: "filter_left_wrapper" }
const _hoisted_199 = { class: "filter_right_wrapper" }
const _hoisted_200 = { src: "/assets/img/filter.svg" }
const _hoisted_201 = { class: "mt-3 total_wrapper" }
const _hoisted_202 = { class: "total" }
const _hoisted_203 = { class: "mt-1 table_trainers_wrapper" }
const _hoisted_204 = {
  key: 4,
  class: "tab_body"
}
const _hoisted_205 = { class: "mt-3 total_wrapper" }
const _hoisted_206 = { class: "mt-1" }
const _hoisted_207 = {
  key: 5,
  class: "tab_body"
}
const _hoisted_208 = { class: "filter_wrapper event_filter_wrapper pt-2" }
const _hoisted_209 = { src: "/assets/img/filter.svg" }
const _hoisted_210 = { class: "mt-3 total_wrapper" }
const _hoisted_211 = {
  key: 6,
  class: "tab_body"
}
const _hoisted_212 = { class: "mt-3 total_wrapper" }
const _hoisted_213 = { class: "total" }
const _hoisted_214 = { class: "mt-1" }
const _hoisted_215 = {
  key: 7,
  class: "tab_body"
}
const _hoisted_216 = {
  key: 8,
  class: "tab_body"
}
const _hoisted_217 = { class: "privacy_wrapper" }
const _hoisted_218 = { class: "privacy" }
const _hoisted_219 = { class: "privacy_label" }
const _hoisted_220 = { class: "mb-0 mt-2" }
const _hoisted_221 = { class: "privacy" }
const _hoisted_222 = { class: "privacy_label" }
const _hoisted_223 = { class: "mb-0 mt-2" }
const _hoisted_224 = { class: "privacy" }
const _hoisted_225 = { class: "privacy_label" }
const _hoisted_226 = { class: "mb-0 mt-2" }
const _hoisted_227 = {
  key: 9,
  class: "tab_body"
}
const _hoisted_228 = { class: "mt-3 total_wrapper" }
const _hoisted_229 = { class: "mt-1" }
const _hoisted_230 = {
  key: 10,
  class: "tab_body"
}

export function render(_ctx, _cache) {
  const _component_v_last_viewed_clients_tabs = _resolveComponent("v-last-viewed-clients-tabs")
  const _component_v_alert = _resolveComponent("v-alert")
  const _component_changeContractStatus = _resolveComponent("changeContractStatus")
  const _component_writeMessageForClient = _resolveComponent("writeMessageForClient")
  const _component_addClientTrainingBlock = _resolveComponent("addClientTrainingBlock")
  const _component_retryToPayTrainingBlock = _resolveComponent("retryToPayTrainingBlock")
  const _component_addPhoto = _resolveComponent("addPhoto")
  const _component_linkPassCard = _resolveComponent("linkPassCard")
  const _component_updateClientSourse = _resolveComponent("updateClientSourse")
  const _component_checkPhoneNumber = _resolveComponent("checkPhoneNumber")
  const _component_addRestriction = _resolveComponent("addRestriction")
  const _component_viewRestrictions = _resolveComponent("viewRestrictions")
  const _component_passCardAlert = _resolveComponent("passCardAlert")
  const _component_paymentExplanationModal = _resolveComponent("paymentExplanationModal")
  const _component_v_client_tabs_menu = _resolveComponent("v-client-tabs-menu")
  const _component_v_input = _resolveComponent("v-input")
  const _component_v_select = _resolveComponent("v-select")
  const _component_v_textarea = _resolveComponent("v-textarea")
  const _component_v_datatable = _resolveComponent("v-datatable")
  const _component_highcharts = _resolveComponent("highcharts")
  const _component_client_chat = _resolveComponent("client-chat")
  const _directive_click_outside = _resolveDirective("click-outside")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_last_viewed_clients_tabs, {
      currentClientId: _ctx.clientId,
      onNavigate: _ctx.onTabNavigate
    }, null, 8, ["currentClientId", "onNavigate"]),
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showRegistrationPassAlert,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showRegistrationPassAlert) = $event)),
      title: 'clients.view.passage',
      html: _ctx.alertRegistrationPassText,
      successButtonText: _ctx.$t('clients.confirm'),
      cancelButtonText: _ctx.$t('clients.view.cancel'),
      onSuccess: _ctx.registerPass,
      onCancel: _cache[1] || (_cache[1] = $event => (_ctx.showRegistrationPassAlert = false))
    }, null, 8, ["modelValue", "title", "html", "successButtonText", "cancelButtonText", "onSuccess"]),
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showAlert,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showAlert) = $event)),
      title: _ctx.alertTitle,
      text: _ctx.alertText,
      successButtonText: _ctx.$t('clients.yes'),
      cancelButtonText: _ctx.$t('clients.view.cancel'),
      onSuccess: _ctx.applySuccessAlertFunction,
      doNotTranslated: !_ctx.isTranslateAlert,
      onCancel: _cache[3] || (_cache[3] = $event => (_ctx.showAlert = false))
    }, null, 8, ["modelValue", "title", "text", "successButtonText", "cancelButtonText", "onSuccess", "doNotTranslated"]),
    (_ctx.showChangeContractStatus)
      ? (_openBlock(), _createBlock(_component_changeContractStatus, {
          key: 0,
          contract: _ctx.currentClient?.contracts[_ctx.currentContractIndex],
          onClose: _ctx.closeChangeContractStausWindow
        }, null, 8, ["contract", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showWriteMessageForClient)
      ? (_openBlock(), _createBlock(_component_writeMessageForClient, {
          key: 1,
          onClose: _cache[4] || (_cache[4] = $event => (_ctx.showWriteMessageForClient = false)),
          clientId: _ctx.clientId,
          hasMobileDevice: _ctx.currentClient?.mobileDevices.length > 0
        }, null, 8, ["clientId", "hasMobileDevice"]))
      : _createCommentVNode("", true),
    (_ctx.showAddClientTrainingBlock)
      ? (_openBlock(), _createBlock(_component_addClientTrainingBlock, {
          key: 2,
          onClose: _ctx.closeAddClientTrainingBlockWindow,
          client: _ctx.currentClient
        }, null, 8, ["onClose", "client"]))
      : _createCommentVNode("", true),
    (_ctx.showRetryToPayTrainingBlock)
      ? (_openBlock(), _createBlock(_component_retryToPayTrainingBlock, {
          key: 3,
          trainingBlockId: _ctx.trainingBlockRetryToPayId,
          hasClientPaymentMean: _ctx.currentClient?.activePaymentMean,
          onClose: _cache[5] || (_cache[5] = $event => (_ctx.showRetryToPayTrainingBlock = false)),
          onUpdate: _ctx.updateTrainingBlocks
        }, null, 8, ["trainingBlockId", "hasClientPaymentMean", "onUpdate"]))
      : _createCommentVNode("", true),
    (_ctx.showAddPhoto)
      ? (_openBlock(), _createBlock(_component_addPhoto, {
          key: 4,
          clientId: _ctx.clientId,
          onClose: _ctx.closeAddPhotoWindow
        }, null, 8, ["clientId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showlinkPassCard)
      ? (_openBlock(), _createBlock(_component_linkPassCard, {
          key: 5,
          onClose: _cache[6] || (_cache[6] = $event => (_ctx.showlinkPassCard = false)),
          clientId: _ctx.clientId,
          onLinkPassCard: _ctx.createPassCard
        }, null, 8, ["clientId", "onLinkPassCard"]))
      : _createCommentVNode("", true),
    (_ctx.showClientSourses)
      ? (_openBlock(), _createBlock(_component_updateClientSourse, {
          key: 6,
          clientId: _ctx.currentClient?.id,
          isRequireSalesChannelSelectionOnSignUp: _ctx.currentClient?.isRequireSalesChannelSelectionOnSignUp,
          clientSourceId: _ctx.currentClient?.clientSourceId,
          onClose: _ctx.closeUpdateClientSourse
        }, null, 8, ["clientId", "isRequireSalesChannelSelectionOnSignUp", "clientSourceId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showCheckPhoneNumber)
      ? (_openBlock(), _createBlock(_component_checkPhoneNumber, {
          key: 7,
          clientId: _ctx.clientId,
          clubId: _ctx.currentClient?.lastClubId,
          prefilledPhone: '',
          onClose: _ctx.closeCheckPhoneNumber,
          onUpdatePhone: _ctx.onPhoneUpdated
        }, null, 8, ["clientId", "clubId", "onClose", "onUpdatePhone"]))
      : _createCommentVNode("", true),
    (_ctx.isShowAddRestriction)
      ? (_openBlock(), _createBlock(_component_addRestriction, {
          key: 8,
          clientId: _ctx.currentClient?.id,
          onClose: _ctx.closeAddRestriction
        }, null, 8, ["clientId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isShowViewRestrictions)
      ? (_openBlock(), _createBlock(_component_viewRestrictions, {
          key: 9,
          restrictions: _ctx.currentClient?.restrictions,
          onClose: _ctx.closeViewRestrictions
        }, null, 8, ["restrictions", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isShowAwaitingCard)
      ? (_openBlock(), _createBlock(_component_passCardAlert, {
          key: 10,
          title: _ctx.passCardAlertTitle,
          onClose: _ctx.closeAwaitingCard
        }, null, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showNextPaymentExplanation)
      ? (_openBlock(), _createBlock(_component_paymentExplanationModal, {
          key: 11,
          orderId: _ctx.nextPaymentExplanationOrderId,
          onClose: _cache[7] || (_cache[7] = $event => (_ctx.showNextPaymentExplanation = false))
        }, null, 8, ["orderId"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("iframe", {
        class: "change_payment_frame",
        ref: "payment_frame",
        src: _ctx.paymentFrameSrc
      }, null, 8, _hoisted_2),
      _createElementVNode("img", {
        class: "frame_close_button",
        src: "/assets/img/close.svg",
        onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.closeFrame && _ctx.closeFrame(...args)))
      })
    ], 512), [
      [_vShow, _ctx.isShowPaymentFrame]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.hasConnection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("a", {
                class: "link_card_button",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.showlinkPassCard = true))
              }, _toDisplayString(_ctx.$t('clients.view.link_card')), 1),
              (_ctx.currentClient?.hasPassCard)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "untie_card",
                    onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.deactivatePassCard && _ctx.deactivatePassCard(...args)))
                  }, _toDisplayString(_ctx.$t('clients.view.untie_card')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_client_tabs_menu, {
        clientId: _ctx.clientId,
        activeTab: _ctx.activeTab.url,
        badges: _ctx.tabBadges,
        onTabClick: _ctx.onClientTabClick
      }, null, 8, ["clientId", "activeTab", "badges", "onTabClick"]),
      (_ctx.activeTab.url == 'profile')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('clients.view.photo')), 1),
                    (_ctx.currentClient?.photoUrl)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "photo",
                          style: _normalizeStyle({ 'background-image': `url(${_ctx.currentClient?.photoUrl})` })
                        }, null, 4))
                      : _createCommentVNode("", true),
                    (_ctx.hasUploadPhotoPermission)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "camera",
                          onClick: _cache[11] || (_cache[11] = $event => (_ctx.showAddPhoto = true))
                        }, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('clients.view.avatar')), 1),
                    (_ctx.currentClient?.avatarUrl)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "photo",
                          style: _normalizeStyle({ 'background-image': `url(${_ctx.currentClient?.avatarUrl})`})
                        }, null, 4))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "photo_button mt-3",
                    onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.createOrRedirectToLead && _ctx.createOrRedirectToLead(...args))),
                    disabled: _ctx.isCreateLeadDisabled
                  }, _toDisplayString(_ctx.currentClient?.hasLead ? _ctx.$t('clients.view.to_crm') :  _ctx.$t('clients.view.create_lead')), 9, _hoisted_17),
                  (_ctx.hasWriteMessagePermission && _ctx.currentClient?.email)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "photo_button mt-3",
                        onClick: _cache[13] || (_cache[13] = $event => (_ctx.showWriteMessageForClient=true))
                      }, _toDisplayString(_ctx.$t('clients.view.write')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, [
                        _createTextVNode(_toDisplayString(_ctx.currentClient?.lastName) + " " + _toDisplayString(_ctx.currentClient?.firstName) + " ", 1),
                        (_ctx.currentClient?.restrictions.length > 0)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "restriction_alert",
                              onClick: _cache[14] || (_cache[14] = $event => (_ctx.isShowViewRestrictions = true))
                            }, _hoisted_24))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass(_ctx.currentClient?.phone || _ctx.isLoad ? 'client_info_phone' : 'client_info_phone error_text')
                      }, _toDisplayString(_ctx.addPhoneMask(_ctx.currentClient?.phone) || _ctx.$t('clients.view.phone_absent')), 3)
                    ]),
                    (_ctx.hasEditPermission || _ctx.hasChangePasswordPermission)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "edit_button",
                            onClick: _cache[15] || (_cache[15] = $event => (_ctx.isShowEditMenu = !_ctx.isShowEditMenu))
                          }, _hoisted_27),
                          _withDirectives(_createElementVNode("div", _hoisted_28, [
                            (_ctx.hasEditPermission)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "edit_menu_item",
                                  onClick: _cache[16] || (_cache[16] = (...args) => (_ctx.openEdit && _ctx.openEdit(...args)))
                                }, _toDisplayString(_ctx.$t('clients.view.edit')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.hasChangePasswordPermission)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "edit_menu_item",
                                  onClick: _cache[17] || (_cache[17] = (...args) => (_ctx.showResetPasswordAlert && _ctx.showResetPasswordAlert(...args)))
                                }, _toDisplayString(_ctx.$t('clients.view.reset_password')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.hasSetRestriction)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: "edit_menu_item",
                                  onClick: _cache[18] || (_cache[18] = $event => (_ctx.isShowAddRestriction = true))
                                }, _toDisplayString(_ctx.$t('clients.view.set_restriction')), 1))
                              : _createCommentVNode("", true)
                          ], 512), [
                            [_vShow, _ctx.isShowEditMenu]
                          ])
                        ])), [
                          [_directive_click_outside, _ctx.onClickOutsideEditMenu]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      (!_ctx.currentClient?.isDisplaySalesChannelInClientProfile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t('clients.view.email')), 1),
                              _createElementVNode("p", {
                                class: _normalizeClass(_ctx.currentClient?.email || _ctx.isLoad ? 'block_info' : 'block_info error_text')
                              }, _toDisplayString(_ctx.currentClient?.email || _ctx.$t('clients.view.absent')), 3)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.currentClient?.isDisplaySalesChannelInClientProfile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('clients.view.email')), 1),
                              _createElementVNode("p", {
                                class: _normalizeClass(_ctx.currentClient?.email || _ctx.isLoad ? 'block_info' : 'block_info error_text')
                              }, _toDisplayString(_ctx.currentClient?.email || _ctx.$t('clients.view.absent')), 3)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('clients.view.sales_channel')), 1),
                              (_ctx.currentClient?.isHighlightEmptySalesChannelInClientProfile)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: _normalizeClass(_ctx.currentClient?.clientSourceName || _ctx.isLoad ? 'block_info can_change_client_sourse' : 'block_info error_text can_change_client_sourse'),
                                    onClick: _cache[19] || (_cache[19] = $event => (_ctx.showClientSourses = true))
                                  }, _toDisplayString(_ctx.currentClient?.clientSourceName || _ctx.$t('clients.view.client_source_absent')), 3))
                                : (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.currentClient?.clientSourceName || _ctx.$t('clients.view.client_source_absent')), 1))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('clients.view.birthday')), 1),
                          _createElementVNode("p", {
                            class: _normalizeClass(_ctx.currentClient?.birthday || _ctx.isLoad ? 'block_info' : 'block_info error_text')
                          }, _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.birthday, "DD MMMM yyyy") || _ctx.$t('clients.view.absent')), 3)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('clients.view.sex')), 1),
                          _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.currentClient?.sex ? _ctx.$t('clients.male') : _ctx.$t('clients.female')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('clients.view.club')), 1),
                          _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.currentClient?.lastClubName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('clients.view.stay')), 1),
                          (_ctx.showPassButtonIn && _ctx.currentClient?.isInClub == false && _ctx.currentClient?.restrictions.length == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _hoisted_54,
                                _createElementVNode("p", {
                                  class: "in_club_status active_pass_registration_button",
                                  onClick: _cache[20] || (_cache[20] = (...args) => (_ctx.showRegistrationPass && _ctx.showRegistrationPass(...args)))
                                }, _toDisplayString(_ctx.$t('clients.view.not_in_club')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.showPassButtonOut && _ctx.currentClient?.isInClub == true && _ctx.currentClient?.restrictions.length == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _hoisted_56,
                                _createElementVNode("p", {
                                  class: "in_club_status active_pass_registration_button",
                                  onClick: _cache[21] || (_cache[21] = (...args) => (_ctx.showRegistrationPass && _ctx.showRegistrationPass(...args)))
                                }, _toDisplayString(_ctx.$t('clients.view.in_club')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ((!_ctx.showPassButtonIn || _ctx.currentClient?.restrictions.length != 0) && _ctx.currentClient?.isInClub == false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                _hoisted_58,
                                _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('clients.view.not_in_club')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ((!_ctx.showPassButtonOut || _ctx.currentClient?.restrictions.length != 0) && _ctx.currentClient?.isInClub == true )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                _hoisted_61,
                                _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t('clients.view.in_club')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.$t('clients.view.last_in')), 1),
                          _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.lastInDate, "DD.MM.yyyy HH:mm") || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.$t('clients.view.last_out')), 1),
                          _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.lastOutDate, "DD.MM.yyyy HH:mm") || '-'), 1)
                        ])
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, !_ctx.isEdit]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(_component_v_input, {
                        class: "edit_client_elment",
                        modelValue: _ctx.tempLastName,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((_ctx.tempLastName) = $event)),
                        label: _ctx.$t('clients.view.lastname'),
                        height: "22",
                        errorText: _ctx.lastnameErrorText,
                        onFocus: _cache[23] || (_cache[23] = $event => (_ctx.lastnameErrorText = '')),
                        clearable: ""
                      }, null, 8, ["modelValue", "label", "errorText"])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_v_input, {
                        class: "edit_client_elment",
                        modelValue: _ctx.tempFirstName,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => ((_ctx.tempFirstName) = $event)),
                        label: _ctx.$t('clients.view.firstname'),
                        height: "22",
                        errorText: _ctx.firstnameErrorText,
                        onFocus: _cache[25] || (_cache[25] = $event => (_ctx.firstnameErrorText = '')),
                        clearable: ""
                      }, null, 8, ["modelValue", "label", "errorText"])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_v_select, {
                        class: "edit_client_elment",
                        modelValue: _ctx.tempSex,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => ((_ctx.tempSex) = $event)),
                        label: 'clients.view.sex',
                        items: _ctx.sex
                      }, null, 8, ["modelValue", "label", "items"])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_component_v_input, {
                        class: "edit_client_elment",
                        modelValue: _ctx.tempEmail,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => ((_ctx.tempEmail) = $event)),
                        label: _ctx.$t('clients.view.email'),
                        height: "22",
                        errorText: _ctx.emailErrorText,
                        onFocus: _cache[28] || (_cache[28] = $event => (_ctx.emailErrorText = '')),
                        clearable: ""
                      }, null, 8, ["modelValue", "label", "errorText"])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _withDirectives(_createVNode(_component_v_input, {
                        class: _normalizeClass(_ctx.tempPhoneConfirmationRequired ? 'edit_client_elment phone_confirmation_required' : 'edit_client_elment phone_confirmation_not_required'),
                        modelValue: _ctx.tempPhone,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => ((_ctx.tempPhone) = $event)),
                        placeholder: "+7 (000) 000-00-00",
                        label: _ctx.$t('clients.view.phone'),
                        height: "22",
                        errorText: _ctx.phoneErrorText,
                        onFocus: _cache[30] || (_cache[30] = $event => (_ctx.phoneErrorText = '')),
                        clearable: "",
                        onClick: _ctx.checkIfPhoneConfirmationRequired
                      }, null, 8, ["class", "modelValue", "label", "errorText", "onClick"]), [
                        [_directive_maska, void 0, _ctx.options]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createVNode(_component_v_input, {
                        class: "edit_client_elment",
                        modelValue: _ctx.tempBirthday,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => ((_ctx.tempBirthday) = $event)),
                        inputType: "date",
                        label: _ctx.$t('clients.view.birthday'),
                        height: "22",
                        errorText: _ctx.birthdayErrorText,
                        min: _ctx.minBirthdayDate,
                        max: _ctx.maxBirthdayDate,
                        onFocus: _cache[32] || (_cache[32] = $event => (_ctx.birthdayErrorText = '')),
                        clearable: ""
                      }, null, 8, ["modelValue", "label", "errorText", "min", "max"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("button", {
                      class: "primary_button button_space",
                      onClick: _cache[33] || (_cache[33] = (...args) => (_ctx.updateClientData && _ctx.updateClientData(...args))),
                      disabled: _ctx.isEditSaveButtonDisabled
                    }, _toDisplayString(_ctx.$t('clients.view.save')), 9, _hoisted_79),
                    _createElementVNode("button", {
                      class: "secondary_button",
                      onClick: _cache[34] || (_cache[34] = $event => (_ctx.isEdit = false))
                    }, _toDisplayString(_ctx.$t('clients.view.cancel')), 1)
                  ])
                ], 512), [
                  [_vShow, _ctx.isEdit]
                ]),
                (_ctx.currentClient?.contracts?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("p", {
                              class: "client_info_agreement",
                              onClick: _cache[35] || (_cache[35] = $event => (_ctx.openContract(_ctx.currentClient?.contracts[_ctx.currentContractIndex].id)))
                            }, _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].agreement) + " (" + _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].clubName) + ")", 1),
                            (_ctx.currentClient?.contracts[_ctx.currentContractIndex].isVip)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "vip_badge",
                                  title: _ctx.$t('clients.view.vipTooltip')
                                }, "VIP", 8, _hoisted_84))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("p", _hoisted_86, _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].contract), 1),
                            (_ctx.currentClient?.contracts[_ctx.currentContractIndex].isChangeContractStatusActive)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "flex client_info_contract_status can_change_status",
                                  onClick: _cache[36] || (_cache[36] = $event => (_ctx.showChangeContractStatus = true))
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass('dot dot_contract_' + _ctx.getContractStatus(_ctx.currentClient?.contracts[_ctx.currentContractIndex].status))
                                  }, null, 2),
                                  _createTextVNode(_toDisplayString(_ctx.$t('contract_status.' + _ctx.getContractStatus(_ctx.currentClient?.contracts[_ctx.currentContractIndex].status))), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass('dot dot_contract_' + _ctx.getContractStatus(_ctx.currentClient?.contracts[_ctx.currentContractIndex].status))
                                  }, null, 2),
                                  _createTextVNode(_toDisplayString(_ctx.$t('contract_status.' + _ctx.getContractStatus(_ctx.currentClient?.contracts[_ctx.currentContractIndex].status))), 1)
                                ])),
                            (_ctx.currentClient?.contracts[_ctx.currentContractIndex].isShowActivateNewContractButton)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "contract_status_pay_button",
                                  onClick: _cache[37] || (_cache[37] = $event => (_ctx.showPayAlert('activateNewContract')))
                                }, _toDisplayString(_ctx.$t('clients.view.pay')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.currentClient?.contracts[_ctx.currentContractIndex].isShowPayDeptButton)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  class: "contract_status_pay_button",
                                  onClick: _cache[38] || (_cache[38] = $event => (_ctx.showPayAlert('payDept')))
                                }, _toDisplayString(_ctx.$t('clients.view.pay')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("p", _hoisted_88, [
                            _createTextVNode(_toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].contractStatusDescription) + " ", 1),
                            (_ctx.currentClient?.contracts[_ctx.currentContractIndex].isShowContractStatusCancelButton)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "contract_status_cancel_button",
                                  onClick: _cache[39] || (_cache[39] = $event => (_ctx.showResetCancelStatusAlert(_ctx.currentClient?.contracts[_ctx.currentContractIndex])))
                                }, _toDisplayString(_ctx.$t('clients.view.cancel')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.currentClient?.contracts.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                              _createElementVNode("button", {
                                onClick: _cache[40] || (_cache[40] = (...args) => (_ctx.previousContact && _ctx.previousContact(...args))),
                                class: _normalizeClass(_ctx.currentContractIndex != 0 ? 'contract_switch_button mr-2' : 'contract_switch_button contract_switch_button_disable mr-2')
                              }, _hoisted_91, 2),
                              _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.currentContractIndex + 1) + "/" + _toDisplayString(_ctx.currentClient?.contracts.length), 1),
                              _createElementVNode("button", {
                                onClick: _cache[41] || (_cache[41] = (...args) => (_ctx.nextContact && _ctx.nextContact(...args))),
                                class: _normalizeClass(_ctx.currentContractIndex != _ctx.currentClient?.contracts.length - 1 ? 'contract_switch_button ml-2' : 'contract_switch_button contract_switch_button_disable ml-2')
                              }, _hoisted_94, 2)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("div", _hoisted_99, [
                                _createElementVNode("p", _hoisted_100, _toDisplayString(_ctx.$t('clients.view.start_date')), 1),
                                _createElementVNode("p", _hoisted_101, _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.contracts[_ctx.currentContractIndex].startDate, "DD.MM.yyyy") || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.$t('clients.view.end_date')), 1),
                                _createElementVNode("p", _hoisted_104, _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.contracts[_ctx.currentContractIndex].endDate, "DD.MM.yyyy") || '-'), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("div", _hoisted_106, [
                              _createElementVNode("div", _hoisted_107, [
                                _createElementVNode("p", _hoisted_108, _toDisplayString(_ctx.$t('clients.view.referralcode')), 1),
                                _createElementVNode("p", _hoisted_109, _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].referralPromocode), 1)
                              ]),
                              _createElementVNode("div", _hoisted_110, [
                                _createElementVNode("p", _hoisted_111, _toDisplayString(_ctx.$t('clients.view.freeze')), 1),
                                _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.$t('clients.view.available_days')) + ": " + _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].availableFreezingDaysNumber), 1)
                              ])
                            ])
                          ])
                        ]),
                        (_ctx.currentClient?.contracts[_ctx.currentContractIndex].pin)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("div", _hoisted_115, [
                                  _createElementVNode("div", _hoisted_116, [
                                    _createElementVNode("p", _hoisted_117, _toDisplayString(_ctx.$t('clients.view.pin')), 1),
                                    _createElementVNode("p", _hoisted_118, _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].pin), 1)
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_121, [
                                _createElementVNode("p", _hoisted_122, _toDisplayString(_ctx.$t('clients.view.previous_payment')), 1),
                                (_ctx.currentClient?.contracts[_ctx.currentContractIndex].previousPaymentDueDate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                      _hoisted_124,
                                      _createElementVNode("p", _hoisted_125, [
                                        _createTextVNode(_toDisplayString(_ctx.getFormatedAmount(_ctx.currentClient?.contracts[_ctx.currentContractIndex].previousPaymentTotal)) + " " + _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].currencySign) + " ", 1),
                                        _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.contracts[_ctx.currentContractIndex].previousPaymentDueDate, "DD.MM.yyyy") || '-'), 1)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_127, _hoisted_129)),
                                _withDirectives(_createElementVNode("div", { class: "client_info_contract_previous_payment_queue" }, "(" + _toDisplayString(_ctx.$t('clients.view.paid')) + " " + _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.contracts[_ctx.currentContractIndex].previousPaymentProcessedDate, "DD.MM.yyyy") || '-') + ")", 513), [
                                  [_vShow, _ctx.currentClient?.contracts[_ctx.currentContractIndex].isShowPreviousPaymentProcessedDate]
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_130, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_131, [
                                _createElementVNode("p", _hoisted_132, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('clients.view.next_payment')), 1),
                                  (_ctx.currentClient?.contracts[_ctx.currentContractIndex].nextPaymentOrderId)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "info_icon_button",
                                        title: _ctx.$t('order.order_details'),
                                        onClick: _cache[42] || (_cache[42] = $event => {_ctx.nextPaymentExplanationOrderId = _ctx.currentClient?.contracts[_ctx.currentContractIndex].nextPaymentOrderId; _ctx.showNextPaymentExplanation = true})
                                      }, "ⓘ", 8, _hoisted_133))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.currentClient?.contracts[_ctx.currentContractIndex].nextPaymentDueDate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.currentClient?.contracts[_ctx.currentContractIndex].isShowNextPaymentDueDate ? 'dot dot_contract_indebt mr-2' : 'dot dot_contract_active mr-2')
                                      }, null, 2),
                                      _createElementVNode("p", _hoisted_135, [
                                        _createTextVNode(_toDisplayString(_ctx.getFormatedAmount(_ctx.currentClient?.contracts[_ctx.currentContractIndex].nextPaymentTotal)) + " " + _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].currencySign) + " ", 1),
                                        _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.contracts[_ctx.currentContractIndex].nextPaymentQueueDate, "DD.MM.yyyy") || '-'), 1),
                                        (_ctx.currentClient?.contracts[_ctx.currentContractIndex].nextPaymentServiceType)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_137, "· " + _toDisplayString(_ctx.$t(_ctx.currentClient?.contracts[_ctx.currentContractIndex].nextPaymentServiceType)), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_138, _hoisted_140)),
                                _withDirectives(_createElementVNode("div", { class: "client_info_contract_previous_payment_queue" }, "(" + _toDisplayString(_ctx.$t('clients.view.in_debt_since')) + " " + _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.contracts[_ctx.currentContractIndex].nextPaymentDueDate, "DD.MM.yyyy") || '-') + ")", 513), [
                                  [_vShow, _ctx.currentClient?.contracts[_ctx.currentContractIndex].isShowNextPaymentDueDate]
                                ]),
                                (_ctx.currentClient?.contracts[_ctx.currentContractIndex].followingPaymentOrderId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_141, _toDisplayString(_ctx.$t('clients.view.next_payment_following')) + ": " + _toDisplayString(_ctx.getFormatedAmount(_ctx.currentClient?.contracts[_ctx.currentContractIndex].followingPaymentTotal)) + " " + _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].currencySign) + " " + _toDisplayString(_ctx.getFormatedDate(_ctx.currentClient?.contracts[_ctx.currentContractIndex].followingPaymentQueueDate, "DD.MM.yyyy")), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        (_ctx.currentClient?.contracts[_ctx.currentContractIndex].services.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                              _createElementVNode("div", _hoisted_143, [
                                _createElementVNode("p", _hoisted_144, _toDisplayString(_ctx.$t('clients.view.services')), 1),
                                _createElementVNode("div", _hoisted_145, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentClient?.contracts[_ctx.currentContractIndex].services, (service) => {
                                    return (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                      _createElementVNode("div", _hoisted_147, [
                                        _createElementVNode("div", _hoisted_148, [
                                          _createElementVNode("p", _hoisted_149, _toDisplayString(service.name), 1),
                                          _createElementVNode("p", _hoisted_150, _toDisplayString(_ctx.getFormatedAmount(service.price)) + " " + _toDisplayString(_ctx.currentClient?.contracts[_ctx.currentContractIndex].currencySign), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_151, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass('dot dot_service_contract_' + _ctx.getServiceContractStatus(service.status))
                                          }, null, 2),
                                          _createTextVNode(_toDisplayString(_ctx.$t('service_contract_status.' + _ctx.getServiceContractStatus(service.status))), 1)
                                        ])
                                      ])
                                    ]))
                                  }), 256))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_152, [
                  _createElementVNode("div", _hoisted_153, [
                    _createElementVNode("div", _hoisted_154, [
                      _createElementVNode("p", _hoisted_155, _toDisplayString(_ctx.$t('clients.view.comments')), 1),
                      (_ctx.hasAddCommentPermission)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "comments_add_button",
                            onClick: _cache[43] || (_cache[43] = $event => {_ctx.newComment = ''; _ctx.editComment = true})
                          }, [
                            _createElementVNode("span", _hoisted_156, _toDisplayString(_ctx.$t('clients.view.add')), 1),
                            _hoisted_157
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_158, [
                      _createElementVNode("button", {
                        class: "edit_button",
                        onClick: _cache[44] || (_cache[44] = $event => (_ctx.showComments = !_ctx.showComments))
                      }, [
                        _createElementVNode("img", {
                          class: "edit_img",
                          src: _ctx.showComments ? '/assets/img/preview-close.svg' : '/assets/img/preview-open.svg'
                        }, null, 8, _hoisted_159)
                      ])
                    ], 512), [
                      [_vShow, _ctx.currentClient?.comments.length > 0]
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_160, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentClient?.comments, (comment) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _createElementVNode("p", _hoisted_163, _toDisplayString(comment.userName), 1),
                          _createElementVNode("p", _hoisted_164, _toDisplayString(_ctx.getFormatedDate(comment.createDate, "DD.MM.yyyy HH:mm") || '-'), 1),
                          (_ctx.hasDeleteCommentPermission)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "delete_comment",
                                src: "/assets/img/close.svg",
                                onClick: $event => (_ctx.showDeleteCommentdAlert(comment.id))
                              }, null, 8, _hoisted_165))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", {
                            class: "comment_text",
                            innerHTML: comment.text
                          }, null, 8, _hoisted_166)
                        ])
                      ]))
                    }), 256))
                  ], 512), [
                    [_vShow, _ctx.showComments]
                  ])
                ], 512), [
                  [_vShow, !_ctx.editComment]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.newComment,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => ((_ctx.newComment) = $event)),
                      label: _ctx.$t('clients.view.new_comment'),
                      errorText: _ctx.newCommentErrorText,
                      onFocus: _cache[46] || (_cache[46] = $event => (_ctx.newCommentErrorText = ''))
                    }, null, 8, ["modelValue", "label", "errorText"])
                  ]),
                  _createElementVNode("div", _hoisted_169, [
                    _createElementVNode("button", {
                      class: "primary_button button_space",
                      onClick: _cache[47] || (_cache[47] = (...args) => (_ctx.createComment && _ctx.createComment(...args))),
                      disabled: _ctx.isNewCommentSaveButtonDisabled
                    }, _toDisplayString(_ctx.$t('clients.view.save')), 9, _hoisted_170),
                    _createElementVNode("button", {
                      class: "secondary_button",
                      onClick: _cache[48] || (_cache[48] = $event => (_ctx.editComment = false))
                    }, _toDisplayString(_ctx.$t('clients.view.cancel')), 1)
                  ])
                ], 512), [
                  [_vShow, _ctx.editComment]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'contracts')
        ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
            (_ctx.isShowNewContractButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "new_mobile_button",
                  onClick: _cache[49] || (_cache[49] = $event => (_ctx.$router.push(`/client/${_ctx.clientId}/contract/create`)))
                }, _toDisplayString(_ctx.$t('clients.view.add_contract')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_172, [
              _withDirectives(_createElementVNode("p", { class: "total" }, _toDisplayString(_ctx.$t('clients.view.total_contracts')) + ": " + _toDisplayString(_ctx.contractsTableData.length), 513), [
                [_vShow, _ctx.contractsTableData.length > 0]
              ]),
              _createElementVNode("div", null, [
                (_ctx.isShowNewContractButton)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "new",
                      onClick: _cache[50] || (_cache[50] = $event => (_ctx.$router.push(`/client/${_ctx.clientId}/contract/create`)))
                    }, _toDisplayString(_ctx.$t('clients.view.add_contract')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_173, [
              _createVNode(_component_v_datatable, {
                class: "pointer",
                columTemplates: _ctx.contractsColumTemplates,
                data: _ctx.contractsTableData,
                onClickOnRow: _ctx.openContract,
                emptyTableClass: 'empty_table_with_margin',
                isLoading: _ctx.isLoad
              }, null, 8, ["columTemplates", "data", "onClickOnRow", "isLoading"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'payment-info')
        ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
            _createElementVNode("div", _hoisted_175, [
              (_ctx.currentClient?.activePaymentMean)
                ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                    _createElementVNode("p", _hoisted_177, [
                      _createTextVNode(_toDisplayString(_ctx.$t('clients.view.card_number')) + ": ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.currentClient?.activePaymentMean.cardNumberMasked), 1)
                    ]),
                    _createElementVNode("p", _hoisted_178, [
                      _createTextVNode(_toDisplayString(_ctx.$t('clients.view.expiry_date')) + ": ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.currentClient?.activePaymentMean.cardExpiryMonth.toString().padStart(2, '0')) + "/" + _toDisplayString(_ctx.currentClient?.activePaymentMean.cardExpiryYear.toString().padStart(4, '0')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_179, [
                      _createTextVNode(_toDisplayString(_ctx.$t('clients.view.card_holder')) + ": ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.currentClient?.activePaymentMean.cardHolder), 1)
                    ]),
                    _createElementVNode("p", _hoisted_180, [
                      _createTextVNode(_toDisplayString(_ctx.$t('clients.view.card_type')) + ": ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getCardType(_ctx.currentClient?.activePaymentMean.cardType)), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_181, _toDisplayString(_ctx.$t('clients.view.no_bank_card_linked')), 1)),
              _createElementVNode("div", _hoisted_182, [
                _createElementVNode("div", _hoisted_183, [
                  _createElementVNode("button", {
                    class: _normalizeClass(_ctx.isShowPayments ? 'payment_button_active' : 'payment_button'),
                    onClick: _cache[51] || (_cache[51] = $event => {_ctx.isShowPayments = true; _ctx.isShowRefunds = false})
                  }, _toDisplayString(_ctx.$t('clients.view.payments')), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(_ctx.isShowRefunds ? 'payment_button_active' : 'payment_button'),
                    onClick: _cache[52] || (_cache[52] = $event => {_ctx.isShowPayments = false; _ctx.isShowRefunds = true})
                  }, _toDisplayString(_ctx.$t('clients.view.refunds')), 3)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.hasChangePaymentPermission)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "payment_change_button",
                        onClick: _cache[53] || (_cache[53] = (...args) => (_ctx.showChangePaymentMean && _ctx.showChangePaymentMean(...args)))
                      }, _toDisplayString(_ctx.$t('clients.view.change_payment_method')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.isShowPaymentFilters ? 'show_filtes_mobile' : 'hide_filtes_mobile mt-2')
              }, [
                _createElementVNode("div", _hoisted_184, [
                  _createElementVNode("div", _hoisted_185, [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.filterPaymentContract,
                      "onUpdate:modelValue": [
                        _cache[54] || (_cache[54] = $event => ((_ctx.filterPaymentContract) = $event)),
                        _ctx.applyPaymentFilter
                      ],
                      label: 'clients.view.contract',
                      class: "w-100",
                      items: _ctx.availableContracts,
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.filterPaymentStatus,
                      "onUpdate:modelValue": [
                        _cache[55] || (_cache[55] = $event => ((_ctx.filterPaymentStatus) = $event)),
                        _ctx.applyPaymentFilter
                      ],
                      label: 'clients.view.status',
                      class: "status_filter_input",
                      items: _ctx.paymentStatus,
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_186, [
                    _createVNode(_component_v_select, {
                      class: "small_filter_input mr-4",
                      modelValue: _ctx.filterPaymentProcessingProvider,
                      "onUpdate:modelValue": [
                        _cache[56] || (_cache[56] = $event => ((_ctx.filterPaymentProcessingProvider) = $event)),
                        _ctx.applyPaymentFilter
                      ],
                      label: 'clients.view.payments_processing_provider',
                      items: _ctx.paymentProcessingProvider,
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                    _createVNode(_component_v_input, {
                      class: "small_filter_input date_input",
                      modelValue: _ctx.filterPaymentDate,
                      "onUpdate:modelValue": [
                        _cache[57] || (_cache[57] = $event => ((_ctx.filterPaymentDate) = $event)),
                        _ctx.applyPaymentFilter
                      ],
                      label: _ctx.$t('clients.view.date'),
                      inputType: "date",
                      height: "22",
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "onUpdate:modelValue"])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    onClick: _cache[58] || (_cache[58] = (...args) => (_ctx.clearPaymentAllFilters && _ctx.clearPaymentAllFilters(...args))),
                    class: "clear_all_filters pl-2"
                  }, _toDisplayString(_ctx.$t('clients.clear_all_filters')), 1)
                ])
              ], 2),
              _createElementVNode("button", {
                class: "filter_button mt-3",
                onClick: _cache[59] || (_cache[59] = $event => (_ctx.isShowPaymentFilters = !_ctx.isShowPaymentFilters))
              }, [
                _createTextVNode(_toDisplayString(!_ctx.isShowPaymentFilters ? _ctx.$t('clients.filter') : _ctx.$t('clients.hide')) + " ", 1),
                _withDirectives(_createElementVNode("img", _hoisted_187, null, 512), [
                  [_vShow, !_ctx.isShowPaymentFilters]
                ])
              ]),
              _createElementVNode("div", _hoisted_188, [
                _createElementVNode("p", _hoisted_189, _toDisplayString(_ctx.$t('clients.view.total_orders')) + ": " + _toDisplayString(_ctx.paymentTableData.length), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.currentClient?.activePaymentMean ? 'mt-1 table_orders_wrapper': 'mt-1 table_orders_wrapper_without_active_payment_mean'),
                onClickCapture: _cache[60] || (_cache[60] = $event => (_ctx.onPaymentMarkerClick($event)))
              }, [
                _createVNode(_component_v_datatable, {
                  class: "pointer",
                  columTemplates: _ctx.paymentColumTemplates,
                  data: _ctx.paymentTableData,
                  onClickOnRow: _ctx.openOrder,
                  isLoading: _ctx.isLoadPayment
                }, null, 8, ["columTemplates", "data", "onClickOnRow", "isLoading"])
              ], 34)
            ], 512), [
              [_vShow, _ctx.isShowPayments]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.isShowRefundFilters ? 'show_filtes_mobile' : 'hide_filtes_mobile mt-2')
              }, [
                _createElementVNode("div", _hoisted_190, [
                  _createElementVNode("div", _hoisted_191, [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.filterRefundContract,
                      "onUpdate:modelValue": [
                        _cache[61] || (_cache[61] = $event => ((_ctx.filterRefundContract) = $event)),
                        _ctx.applyRefundFilter
                      ],
                      label: 'clients.view.contract',
                      class: "w-100",
                      items: _ctx.availableContracts,
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_192, [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.filterRefundStatus,
                      "onUpdate:modelValue": [
                        _cache[62] || (_cache[62] = $event => ((_ctx.filterRefundStatus) = $event)),
                        _ctx.applyRefundFilter
                      ],
                      label: 'clients.view.status',
                      class: "small_filter_input mr-4",
                      items: _ctx.refundStatus,
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                    _createVNode(_component_v_input, {
                      class: "small_filter_input date_input",
                      modelValue: _ctx.filterRefundDate,
                      "onUpdate:modelValue": [
                        _cache[63] || (_cache[63] = $event => ((_ctx.filterRefundDate) = $event)),
                        _ctx.applyRefundFilter
                      ],
                      label: _ctx.$t('clients.view.date'),
                      inputType: "date",
                      height: "22",
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "onUpdate:modelValue"])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", {
                    onClick: _cache[64] || (_cache[64] = (...args) => (_ctx.clearRefundAllFilters && _ctx.clearRefundAllFilters(...args))),
                    class: "clear_all_filters pl-2"
                  }, _toDisplayString(_ctx.$t('clients.clear_all_filters')), 1)
                ])
              ], 2),
              _createElementVNode("button", {
                class: "filter_button mt-3",
                onClick: _cache[65] || (_cache[65] = $event => (_ctx.isShowRefundFilters = !_ctx.isShowRefundFilters))
              }, [
                _createTextVNode(_toDisplayString(!_ctx.isShowRefundFilters ? _ctx.$t('clients.filter') : _ctx.$t('clients.hide')) + " ", 1),
                _withDirectives(_createElementVNode("img", _hoisted_193, null, 512), [
                  [_vShow, !_ctx.isShowRefundFilters]
                ])
              ]),
              _createElementVNode("div", _hoisted_194, [
                _createElementVNode("p", _hoisted_195, _toDisplayString(_ctx.$t('clients.view.total_refunds')) + ": " + _toDisplayString(_ctx.refundTableData.length), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.currentClient?.activePaymentMean ? 'mt-1 table_orders_wrapper': 'mt-1 table_orders_wrapper_without_active_payment_mean')
              }, [
                _createVNode(_component_v_datatable, {
                  class: "pointer",
                  columTemplates: _ctx.refundColumTemplates,
                  data: _ctx.refundTableData,
                  onClickOnRow: _ctx.openRefundOrder,
                  isLoading: _ctx.isLoadPayment
                }, null, 8, ["columTemplates", "data", "onClickOnRow", "isLoading"])
              ], 2)
            ], 512), [
              [_vShow, _ctx.isShowRefunds]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'trainings')
        ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.isShowPaymentFilters ? 'show_filtes_mobile' : 'hide_filtes_mobile mt-2')
            }, [
              _createElementVNode("div", _hoisted_197, [
                _createElementVNode("div", _hoisted_198, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.filterTraining,
                    "onUpdate:modelValue": [
                      _cache[66] || (_cache[66] = $event => ((_ctx.filterTraining) = $event)),
                      _ctx.applyTrainingFilter
                    ],
                    label: 'clients.view.training',
                    class: "training_left_filter",
                    items: _ctx.trainings,
                    clearable: ""
                  }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.filterTrainingTrainer,
                    "onUpdate:modelValue": [
                      _cache[67] || (_cache[67] = $event => ((_ctx.filterTrainingTrainer) = $event)),
                      _ctx.applyTrainingFilter
                    ],
                    label: 'clients.view.trainer',
                    class: "training_right_filter",
                    items: _ctx.trainingTrainers,
                    clearable: ""
                  }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_199, [
                  _createVNode(_component_v_select, {
                    class: "small_filter_input mr-4",
                    modelValue: _ctx.filterTrainingClubZone,
                    "onUpdate:modelValue": [
                      _cache[68] || (_cache[68] = $event => ((_ctx.filterTrainingClubZone) = $event)),
                      _ctx.applyTrainingFilter
                    ],
                    label: 'clients.view.club_zone',
                    items: _ctx.trainingClubZones,
                    clearable: ""
                  }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                  _createVNode(_component_v_input, {
                    class: "small_filter_input date_input",
                    modelValue: _ctx.filterTrainingStartDate,
                    "onUpdate:modelValue": [
                      _cache[69] || (_cache[69] = $event => ((_ctx.filterTrainingStartDate) = $event)),
                      _ctx.applyTrainingFilter
                    ],
                    label: _ctx.$t('clients.view.start_date'),
                    inputType: "date",
                    height: "22",
                    clearable: ""
                  }, null, 8, ["modelValue", "label", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  onClick: _cache[70] || (_cache[70] = (...args) => (_ctx.clearTrainingAllFilters && _ctx.clearTrainingAllFilters(...args))),
                  class: "clear_all_filters pl-2"
                }, _toDisplayString(_ctx.$t('clients.clear_all_filters')), 1)
              ])
            ], 2),
            _createElementVNode("button", {
              class: "filter_button mt-3",
              onClick: _cache[71] || (_cache[71] = $event => (_ctx.isShowPaymentFilters = !_ctx.isShowPaymentFilters))
            }, [
              _createTextVNode(_toDisplayString(!_ctx.isShowPaymentFilters ? _ctx.$t('clients.filter') : _ctx.$t('clients.hide')) + " ", 1),
              _withDirectives(_createElementVNode("img", _hoisted_200, null, 512), [
                [_vShow, !_ctx.isShowPaymentFilters]
              ])
            ]),
            _createElementVNode("div", _hoisted_201, [
              _createElementVNode("p", _hoisted_202, _toDisplayString(_ctx.$t('clients.view.total_trainings')) + ": " + _toDisplayString(_ctx.trainingTableData.length), 1)
            ]),
            _createElementVNode("div", _hoisted_203, [
              _createVNode(_component_v_datatable, {
                columTemplates: _ctx.trainingColumTemplates,
                data: _ctx.trainingTableData,
                isLoading: _ctx.isLoadTraining
              }, null, 8, ["columTemplates", "data", "isLoading"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'referral-program')
        ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
            _createElementVNode("div", _hoisted_205, [
              _withDirectives(_createElementVNode("p", { class: "total" }, _toDisplayString(_ctx.$t('clients.view.total_invitations')) + ": " + _toDisplayString(_ctx.invitationsTableData.length), 513), [
                [_vShow, _ctx.invitationsTableData.length > 0]
              ])
            ]),
            _createElementVNode("div", _hoisted_206, [
              _createVNode(_component_v_datatable, {
                columTemplates: _ctx.invitationsColumTemplates,
                data: _ctx.invitationsTableData,
                emptyTableClass: 'empty_table_with_margin',
                isLoading: _ctx.isLoadReferralMembers
              }, null, 8, ["columTemplates", "data", "isLoading"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'events')
        ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.isShowEventFilters ? 'show_filtes_mobile' : 'hide_filtes_mobile mt-2')
            }, [
              _createElementVNode("div", _hoisted_208, [
                _createVNode(_component_v_select, {
                  class: "small_filter_input",
                  modelValue: _ctx.filterEventMonth,
                  "onUpdate:modelValue": [
                    _cache[72] || (_cache[72] = $event => ((_ctx.filterEventMonth) = $event)),
                    _ctx.applyEventFilter
                  ],
                  label: 'clients.view.date',
                  items: _ctx.eventMonths,
                  clearable: ""
                }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                _createVNode(_component_v_select, {
                  class: "small_filter_input",
                  modelValue: _ctx.filterEventUser,
                  "onUpdate:modelValue": [
                    _cache[73] || (_cache[73] = $event => ((_ctx.filterEventUser) = $event)),
                    _ctx.applyEventFilter
                  ],
                  label: 'clients.view.employee',
                  items: _ctx.eventUsers,
                  clearable: "",
                  labelWithEllipsis: ""
                }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                _createVNode(_component_v_select, {
                  class: "event_type_filter_input",
                  modelValue: _ctx.filterEventType,
                  "onUpdate:modelValue": [
                    _cache[74] || (_cache[74] = $event => ((_ctx.filterEventType) = $event)),
                    _ctx.applyEventFilter
                  ],
                  label: 'clients.view.event_type',
                  items: _ctx.eventTypes,
                  clearable: "",
                  labelWithEllipsis: ""
                }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                _createElementVNode("p", {
                  onClick: _cache[75] || (_cache[75] = (...args) => (_ctx.clearEventAllFilters && _ctx.clearEventAllFilters(...args))),
                  class: "clear_all_filters"
                }, _toDisplayString(_ctx.$t('clients.clear_all_filters')), 1)
              ])
            ], 2),
            _createElementVNode("button", {
              class: "filter_button mt-3",
              onClick: _cache[76] || (_cache[76] = $event => (_ctx.isShowEventFilters = !_ctx.isShowEventFilters))
            }, [
              _createTextVNode(_toDisplayString(!_ctx.isShowEventFilters ? _ctx.$t('clients.filter') : _ctx.$t('clients.hide')) + " ", 1),
              _withDirectives(_createElementVNode("img", _hoisted_209, null, 512), [
                [_vShow, !_ctx.isShowEventFilters]
              ])
            ]),
            _createElementVNode("div", _hoisted_210, [
              _withDirectives(_createElementVNode("p", { class: "total" }, _toDisplayString(_ctx.$t('clients.view.total_events')) + ": " + _toDisplayString(_ctx.eventsTableData.length), 513), [
                [_vShow, _ctx.eventsColumTemplates.length > 0]
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.filterEventMonth || _ctx.filterEventUser || _ctx.filterEventType ? 'mt-1 events_table events_table_filtered' : 'mt-1 events_table'),
              onClickCapture: _cache[77] || (_cache[77] = $event => (_ctx.onEventMarkerClick($event)))
            }, [
              _createVNode(_component_v_datatable, {
                ref: "eventsTable",
                columTemplates: _ctx.eventsColumTemplates,
                data: _ctx.eventsTableData,
                emptyTableClass: 'empty_table_with_margin',
                isLoading: _ctx.isLoadEvents
              }, null, 8, ["columTemplates", "data", "isLoading"])
            ], 34)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'training-blocks')
        ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
            (_ctx.hasAddClientBlockPermission)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "new_mobile_button",
                  onClick: _cache[78] || (_cache[78] = () => {})
                }, _toDisplayString(_ctx.$t('clients.view.add_block')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_212, [
              _createElementVNode("p", _hoisted_213, _toDisplayString(_ctx.$t('clients.view.total_blocks')) + ": " + _toDisplayString(_ctx.trainingBlocksTableData.length), 1),
              _createElementVNode("div", null, [
                (_ctx.hasAddClientBlockPermission)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "new",
                      onClick: _cache[79] || (_cache[79] = $event => (_ctx.showAddClientTrainingBlock = true))
                    }, _toDisplayString(_ctx.$t('clients.view.add_block')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_214, [
              _createVNode(_component_v_datatable, {
                class: "pointer",
                columTemplates: _ctx.blockColumTemplates,
                data: _ctx.trainingBlocksTableData,
                emptyTableClass: 'empty_table_with_margin',
                onClickOnButton: _ctx.clickOnTableButton,
                isLoading: _ctx.isLoadTrainingBlocks
              }, null, 8, ["columTemplates", "data", "onClickOnButton", "isLoading"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'attendance')
        ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
            (_ctx.monthlyAttendanceChartOptions)
              ? (_openBlock(), _createBlock(_component_highcharts, {
                  key: 0,
                  class: "mt-3",
                  options: _ctx.monthlyAttendanceChartOptions
                }, null, 8, ["options"]))
              : _createCommentVNode("", true),
            (_ctx.yearAttendanceChartOptions)
              ? (_openBlock(), _createBlock(_component_highcharts, {
                  key: 1,
                  options: _ctx.yearAttendanceChartOptions
                }, null, 8, ["options"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'privacy-and-notifications')
        ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_217, [
                _createElementVNode("div", _hoisted_218, [
                  _createElementVNode("p", _hoisted_219, _toDisplayString(_ctx.$t('clients.view.visible_to_others')), 1),
                  _createElementVNode("p", _hoisted_220, _toDisplayString(_ctx.currentClient?.visibleToOthers ? _ctx.$t('clients.yes') : _ctx.$t('clients.no')), 1)
                ]),
                _createElementVNode("div", _hoisted_221, [
                  _createElementVNode("p", _hoisted_222, _toDisplayString(_ctx.$t('clients.view.show_contact_info_to_others')), 1),
                  _createElementVNode("p", _hoisted_223, _toDisplayString(_ctx.currentClient?.showContactInfoToOthers ? _ctx.$t('clients.yes') : _ctx.$t('clients.no')), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentClient?.consents, (privacy) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_224, [
                    _createElementVNode("p", _hoisted_225, _toDisplayString(_ctx.$t(privacy.type)), 1),
                    _createElementVNode("p", _hoisted_226, _toDisplayString(privacy.isEnabled ? _ctx.$t('clients.yes') : _ctx.$t('clients.no')), 1)
                  ]))
                }), 256))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'mobile-devices')
        ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
            _createElementVNode("div", _hoisted_228, [
              _withDirectives(_createElementVNode("p", { class: "total" }, _toDisplayString(_ctx.$t('clients.view.total_devices')) + ": " + _toDisplayString(_ctx.mobileDevicesTableData.length), 513), [
                [_vShow, _ctx.mobileDevicesTableData.length > 0]
              ])
            ]),
            _createElementVNode("div", _hoisted_229, [
              _createVNode(_component_v_datatable, {
                columTemplates: _ctx.mobileDevicesColumTemplates,
                data: _ctx.mobileDevicesTableData,
                emptyTableClass: 'empty_table_with_margin',
                isLoading: _ctx.isLoad
              }, null, 8, ["columTemplates", "data", "isLoading"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab.url == 'chat' && _ctx.currentClient)
        ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
            _createVNode(_component_client_chat, {
              clientId: _ctx.clientId,
              clientClubId: _ctx.currentClient?.lastClubId,
              onUpdateBadge: _ctx.updateChatBadge
            }, null, 8, ["clientId", "clientClubId", "onUpdateBadge"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}